// Customizable Area Start
import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import PhoneInput from "react-phone-input-2";
import { StepPhoneProps } from "./types";

const StepPhone: React.FC<StepPhoneProps> = ({
  phone,
  phoneError,
  loading,
  onPhoneChange,
  onContinue,
  onBack,
}) => {
  const isPhoneValid = phone.replace(/\D/g, "").length >= 7;

  return (
    <Box>
      <Typography
        style={{
          fontSize: 20,
          fontWeight: 700,
          fontFamily: "Inter",
          marginBottom: 8,
          textAlign: "center",
          color: "#0F172A",
        }}
      >
        Enter your mobile number
      </Typography>
      <Typography
        variant="body2"
        style={{
          textAlign: "center",
          marginBottom: 28,
          fontFamily: "Inter",
          color: "#64748B",
          lineHeight: 1.6,
        }}
      >
        We never share this publicly. We only verify your number to make sure
        you are you.
      </Typography>

      <Box style={{ marginBottom: phoneError ? 4 : 12 }}>
        <PhoneInput
          country="us"
          value={phone}
          onChange={onPhoneChange}
          placeholder="Enter mobile number"
          specialLabel=""
          enableSearch
          buttonStyle={{
            border: "1px solid #CBD5E1",
            borderRight: "none",
            borderRadius: "8px 0 0 8px",
            background: "#fff",
          }}
          inputStyle={{
            width: "100%",
            height: "52px",
            padding: "12px 12px 12px 52px",
            fontSize: 16,
            border: "1px solid #CBD5E1",
            borderRadius: 8,
            fontFamily: "Inter",
            boxSizing: "border-box" as const,
            outline: "none",
          }}
          containerStyle={{ width: "100%" }}
        />
      </Box>

      {phoneError ? (
        <Typography
          variant="caption"
          style={{
            color: "#EF4444",
            display: "block",
            marginBottom: 12,
            fontFamily: "Inter",
          }}
        >
          {phoneError}
        </Typography>
      ) : null}

      <Typography
        variant="caption"
        display="block"
        style={{
          marginBottom: 28,
          color: "#94A3B8",
          fontFamily: "Inter",
          lineHeight: 1.6,
        }}
      >
        {`By tapping "Continue" you agree to our privacy policy and authorize Everybrand to send you a verification text. Message/data rates may apply.`}
      </Typography>

      <Button
        variant="contained"
        fullWidth
        disabled={!isPhoneValid || loading}
        onClick={onContinue}
        style={{
          backgroundColor: "#000",
          color: "#fff",
          borderRadius: 24,
          textTransform: "none",
          padding: "13px 0",
          fontSize: 16,
          fontFamily: "Inter",
          fontWeight: 600,
          marginBottom: 12,
        }}
      >
        {loading ? "Sending…" : "Continue"}
      </Button>

      <Button
        fullWidth
        onClick={onBack}
        style={{
          borderRadius: 24,
          textTransform: "none",
          color: "#64748B",
          fontSize: 14,
          fontFamily: "Inter",
        }}
      >
        Back
      </Button>
    </Box>
  );
};

export default StepPhone;
// Customizable Area End
